import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config";

function ModifyChatbot() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [chatbotTitle, setChatbotTitle] = useState("");
  const [chatbotName, setChatbotName] = useState("");
  const [userName, setUserName] = useState("");
  const [newContent, setNewContent] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [isContentLoaded, setIsContentLoaded] = useState(false);

  /* -------------------------------
     FETCH CHATBOT DATA
  -------------------------------- */
  useEffect(() => {
    const fetchChatbot = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/chatbot/${id}`);
        const data = await response.json();

        if (response.ok) {
          // setChatbotTitle(data.chatbot_title || "");
          setChatbotName(data.chatbot_name || "");
          setUserName(data.user_name || "");
          setNewContent(data.content || "");
          setIsContentLoaded(true);
        } else {
          console.error("Failed to fetch chatbot data:", data);
        }
      } catch (error) {
        console.error("Error fetching chatbot data:", error);
      }
    };

    fetchChatbot();
  }, [id]);

  /* -------------------------------
     UPDATE CHATBOT
  -------------------------------- */
  const handleModify = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/modify-chatbot/${id}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          // chatbot_title: chatbotTitle,
          chatbot_name: chatbotName,
          user_name: userName,
          content: newContent,
        }),
      });

      if (response.ok) {
        alert("Clone updated successfully!");
        navigate("/");
      } else {
        alert("Failed to update clone.");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  /* -------------------------------
     MODAL HANDLERS
  -------------------------------- */
  const openModal = () => {
    setModalContent(newContent);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setNewContent(modalContent);
    setIsModalOpen(false);
  };

  /* -------------------------------
     UI
  -------------------------------- */
  return (
    <div className="min-h-screen bg-slate-900 text-slate-100 flex items-center justify-center px-4">
      <div className="w-full max-w-4xl bg-slate-950 border border-slate-800 rounded-xl p-6 shadow-xl">

        {/* HEADER */}
        <div className="mb-6">
          <h1 className="text-xl font-semibold">
            Modify{" "}
            <span className="text-emerald-400">
              {chatbotTitle || "Chatbot"}
            </span>
          </h1>
          <p className="text-sm text-slate-400">
            Update chatbot details and training content
          </p>
        </div>

        {/* BASIC DETAILS */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          {/* <input
            type="text"
            value={chatbotTitle}
            onChange={(e) => setChatbotTitle(e.target.value)}
            placeholder="Clone Title"
            className="bg-slate-800 border border-slate-700 rounded-lg px-3 py-2
                       text-sm focus:ring-2 focus:ring-emerald-500 outline-none"
          /> */}

          <input
            type="text"
            value={chatbotName}
            onChange={(e) => setChatbotName(e.target.value)}
            placeholder="Chatbot Name"
            className="bg-slate-800 border border-slate-700 rounded-lg px-3 py-2
                       text-sm focus:ring-2 focus:ring-emerald-500 outline-none"
          />

          <input
            type="text"
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
            placeholder="User Name"
            className="bg-slate-800 border border-slate-700 rounded-lg px-3 py-2
                       text-sm focus:ring-2 focus:ring-emerald-500 outline-none"
          />
        </div>

        {/* CONTENT EDITOR */}
        <div className="mb-3">
          <label className="block text-xs text-slate-400 mb-1">
            Training Content
          </label>
          <textarea
            value={newContent}
            onChange={(e) => setNewContent(e.target.value)}
            rows={10}
            className="w-full bg-slate-800 border border-slate-700 rounded-lg
                       px-3 py-2 text-sm focus:ring-2 focus:ring-emerald-500
                       outline-none resize-none"
          />
        </div>

        {/* ACTIONS */}
        <div className="flex justify-between items-center mt-4">
          <button
            onClick={openModal}
            disabled={!isContentLoaded}
            className={`text-xs ${isContentLoaded
              ? "text-emerald-400 hover:underline"
              : "text-slate-500 cursor-not-allowed"
              }`}
          >
            Open in large editor
          </button>

          <button
            onClick={handleModify}
            className="rounded-lg bg-emerald-500 text-slate-900
                       px-5 py-2 text-sm font-semibold
                       hover:bg-emerald-400 transition"
          >
            Update Clone
          </button>
        </div>
      </div>

      {/* ---------------- MODAL ---------------- */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 px-4">
          <div className="bg-slate-950 border border-slate-800 rounded-xl
                          w-full max-w-6xl h-[90vh] flex flex-col p-6">

            <h2 className="text-lg font-semibold mb-3">
              Edit Content (Large View)
            </h2>

            <textarea
              value={modalContent}
              onChange={(e) => setModalContent(e.target.value)}
              className="flex-1 bg-slate-800 border border-slate-700 rounded-lg
                         px-4 py-3 text-sm focus:ring-2 focus:ring-emerald-500
                         outline-none resize-none"
            />

            <div className="flex justify-end gap-3 mt-4">
              <button
                onClick={() => setIsModalOpen(false)}
                className="px-4 py-2 text-sm rounded-lg
                           border border-slate-700 hover:bg-slate-800"
              >
                Cancel
              </button>

              <button
                onClick={closeModal}
                className="px-4 py-2 text-sm rounded-lg
                           bg-emerald-500 text-slate-900
                           font-semibold hover:bg-emerald-400 transition"
              >
                Save & Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ModifyChatbot;
